const smoothScrollToElement = ({
  element,
  spread = 30,
  frames = 60
}) => {
  if (!element) return;
  const documentBody = document.documentElement.scrollTop || document.body.scrollTop;
  const elm = document.body;
  let from = 0;
  const to = element.getBoundingClientRect();
  const toPosition = documentBody === 0 ? to.top - from - spread : to.top - spread;
  const currentPosition = window.pageYOffset;
  const jump = (toPosition - from) / frames;
  from = currentPosition;
  let remainingFrames = frames;
  function scroll() {
    if (remainingFrames > 0) {
      const position = from + jump;
      from = position;
      elm.scrollTop = from;
      document.documentElement.scrollTop = from;
      remainingFrames--;
      window.requestAnimationFrame(scroll);
    } else {
      const focusableElements = Array.from(
        element.querySelectorAll("a, button")
      );
      element.focus({ preventScroll: true });
      if (focusableElements.length > 0) {
        focusableElements[0].focus({ preventScroll: true });
      }
    }
  }
  window.requestAnimationFrame(scroll);
};
export {
  smoothScrollToElement
};
//# sourceMappingURL=smoothScrollToElement.js.map
